import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import EmlAthnNoSendApi from "Apis/EmlAthnNoSendApi";
import EmlAthnNoVrfRqstApi from "Apis/EmlAthnNoVrfRqstApi";
import EmlAddrDupChkApi from "Apis/EmlAddrDupChkApi";
import CptchUi from "./CptchUi";
import { Helmet } from 'react-helmet-async';
import useRecaptcha from 'Utils/useRecaptcha';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import { validateInput } from './XssFilter';
import { useAsyncAction } from 'hooks/useAsyncAction';
import ApiError from "./ApiError";
import ApiResultModal from "Components/ApiResultModal";

import "./EmlAthnModalUi.css";
import "../Assets/css/MembJoin.css";

// props: emlAthnPrpsCd, onSuccess(athnPrpsCd, email), onClose()
const EmlAthnModalUi = ({ emlAthnPrpsCd, onSuccess, onClose }:any) => {
    const {isLoading,error,data: langData}:any = UseLangLstQuery("EML");
    const [emlAddrDopChkVal,setEmlAddrDopChkVal] = useState("");
    const [emlAddrDopChkLbl,setEmlAddrDopChkLbl] = useState("");
    const [emlAthnChkLbl,setEmlAthnChkLbl] = useState("");
    const [emlAthnNoTimer,setEmlAthnNoTimer] = useState<number>(0);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const { getToken } = useRecaptcha();
    const timerInterval = 1000;
    const timerMinutes = String(Math.floor((emlAthnNoTimer / (1000 * 60)) % 60)).padStart(2, '0');
    const timerSecond = String(Math.floor((emlAthnNoTimer / 1000) % 60)).padStart(2, '0');
    const emlRole = /^[a-zA-Z0-9+-\_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const emlAthnNoRole = /^[0-9]{6}$/;

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    const [membEml,setMembEml] = useState('');
    const [authNoVal,setAuthNoVal] = useState('');

    const resetResultLabels = () => {
        setEmlAddrDopChkLbl("");
        setEmlAthnChkLbl("");
    };

    const MembEmlHandler = (event:any) => {
        setEmlAddrDopChkVal("");
        resetResultLabels();
        setMembEml(validateInput(event.currentTarget.value, 'email', false));
    }
    const AuthNoValHandler = (event:any) => {
        setEmlAthnChkLbl("");
        const value = event.currentTarget.value;
        const filteredValue = validateInput(value, 'basic', false);
        const numericValue = filteredValue.replace(/[^0-9]/g, '').slice(0, 6);
        setAuthNoVal(numericValue);
    }
    // 특정 목적 코드용 이메일 존재 확인 후 인증번호 발송 비동기 함수
    const performSpecialAuthSend = async (membEml: string, emlAthnPrpsCd: string) => {
        const token = await getToken('email_auth');
        const resp = await EmlAddrDupChkApi(membEml, token);
        if(resp.apiHdr.code == "COMM0000") {
            if(resp.apiBody.yn =="N") {
                setEmlAddrDopChkLbl("찾을 수 없는 이메일입니다.");
            } else if (resp.apiBody.yn == "Y") {
                await performNormalAuthSend(membEml, emlAthnPrpsCd);
            }
        }
        else {
            ApiError(langData, resp.apiHdr.code);
        }
    };
    // 일반 인증번호 발송 비동기 함수
    const performNormalAuthSend = async (membEml: string, emlAthnPrpsCd: string) => {
        const token = await getToken('email_auth');
        const resp = await EmlAthnNoSendApi(membEml, emlAthnPrpsCd, token);
        if(resp.apiHdr.code == "ATHN2122") {
            setEmlAthnChkLbl(`${langData&&langData.EML_ATHN_NO_INPUT_DESC_02}`);
        } else {
            setEmlAthnNoTimer((resp.apiBody.exprTime)*1000);
        }
    };
    const executeSpecialAuthSend = useAsyncAction(performSpecialAuthSend);
    const executeNormalAuthSend = useAsyncAction(performNormalAuthSend);
    const EmlAthnSendFunc = () => {
        resetResultLabels();
        switch(emlAthnPrpsCd) {
            case "OTP_REG":
            case "PWD_RSET":
            case "PWD_RSET_MYPAGE":
            case "OTP_UNREG":
            case "OTP_UNREG_MYPAGE":
            case "PASSWD_CHNG":
            case "EML_CHNG_ATHN":
            case "MEMB_FIND":
            case "MEMB_LVD":
            case "SCND_PWD_RSET":
                if(!emlRole.test(membEml)) {
                    return setEmlAddrDopChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_02}`);
                }else {
                    executeSpecialAuthSend(membEml, emlAthnPrpsCd);
                }
            break;
            default:
                if(emlAddrDopChkVal !="N") {
                    return setEmlAddrDopChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_01}`);
                }else {
                    executeNormalAuthSend(membEml, emlAthnPrpsCd);
                }
            break;
        }
    }
    // 이메일 인증번호 검증 비동기 함수
    const performEmailAuthVerification = async (authNoVal: string) => {
        const token = await getToken('email_verify');
        const resp = await EmlAthnNoVrfRqstApi(authNoVal, token);
        if(resp.apiBody !=null && resp.apiBody.athnPrpsCd !=null) {
            setEmlAthnChkLbl("");
            if (onSuccess) onSuccess(resp.apiBody.athnPrpsCd, membEml);
        }
        if(resp.apiHdr.code == "ATHN2100") {
            setEmlAthnChkLbl(`${langData&&langData.EML_ATHN_NO_INPUT_DESC_01}`);
        }
        if(resp.apiHdr.code !="ATHN0000" && resp.apiHdr.code != "ATHN2100") {
            setEmlAthnChkLbl(`${langData&&langData.EML_ATHN_NO_INPUT_DESC_01}  ${resp.apiHdr.code}`);
        }
    };
    const executeEmailAuthVerification = useAsyncAction(performEmailAuthVerification);
    const EmlAthnVrfFunc = (authNoVal:string) => {
        setEmlAthnChkLbl("");
        if(membEml == "" ) {
            return
        }
        switch(emlAthnPrpsCd) {
            case "MEMB_JOIN":
                if(emlAddrDopChkVal != "N") {
                    return setEmlAthnChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_01}`);
                }
            break;
            default:
            break;
        }
        if(!emlAthnNoRole.test(authNoVal)) {
            setEmlAthnChkLbl(`${langData&&langData.EML_ATHN_NO_INPUT_DESC_01}`);
        }else {
            executeEmailAuthVerification(authNoVal);
        }
    }
    // 이메일 중복 확인 비동기 함수
    const performEmailDupCheck = async (membEml: string) => {
        const token = await getToken('email_dup');
        const resp = await EmlAddrDupChkApi(membEml, token);
        switch(resp.apiHdr.code) {
            case "COMM0000":
                setEmlAddrDopChkVal(resp.apiBody.yn);
                if(resp.apiBody.yn =="N") {
                    setEmlAddrDopChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_04}`);
                }else {
                    setEmlAddrDopChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_03}`);
                }
                break;
            default:
                ApiError(langData,resp.apiHdr.code);
                return;
        }
    };
    const executeEmailDupCheck = useAsyncAction(performEmailDupCheck);
    const EmlAddrDupChkFunc = (membEml:string) => {
        resetResultLabels();
        if(!emlRole.test(membEml)) {
            setEmlAddrDopChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_02}`);
        }else {
            executeEmailDupCheck(membEml);
        }
    }
    useEffect(() => {
        let EmlAthnTimerFunc: NodeJS.Timeout | null = null;
        if (emlAthnNoTimer > 0) {
            EmlAthnTimerFunc = setInterval(() => {
                setEmlAthnNoTimer((prevTime) => {
                    const newTime = prevTime - timerInterval;
                    if (newTime <= 0) {
                        return 0;
                    }
                    return newTime;
                });
            }, timerInterval);
        }
        return () => {
            if (EmlAthnTimerFunc) {
                clearInterval(EmlAthnTimerFunc);
            }
        };
    }, [emlAthnNoTimer]);
    return ReactDOM.createPortal(
        <div className="emlAthnModalPortalOverlay" style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:2000,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={onClose}>
            <div className="emlAthnModalPortalContent popContainer" style={{background:'#fff',borderRadius:8,maxWidth:400,width:'90%',padding:24,position:'relative'}} onClick={e => e.stopPropagation()}>
                <button style={{position:'absolute',top:8,right:8,fontSize:20,border:'none',background:'none',cursor:'pointer'}} onClick={onClose}>×</button>
                <ApiResultModal
                    open={resultModalOpen}
                    message={resultModalMessage}
                    onClose={closeResultModal}
                    confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
                />
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.EML_ATHN_POP_MAIN_TITL_00}`}</title>
                </Helmet>
                <div className="emlAthnImgWrap">
                    <img className="emlAthnImg" src={process.env.PUBLIC_URL + "/images/EmlAthnIcon.png"} alt="" />
                </div>
                <h1>{langData&&langData.EML_ATHN_POP_MAIN_TITL_00}</h1>
                <div className="emailInputWrap mt35">
                    <p>{langData&&langData.EML_ATHN_EML_INPUT_TITL_00}</p>
                    {/* 이메일 */}
                    <div className="relative mt10">
                        <input type="text" placeholder={langData&&langData.EML_ATHN_EML_INPUT_DESC_00} onChange={MembEmlHandler} />
                        {/* 이메일을 입력해주세요 */}
                        { emlAthnPrpsCd =="MEMB_JOIN"||emlAthnPrpsCd =="EML_CHNG" ? 
                            <button className="emlDupChkBtn" onClick={() => EmlAddrDupChkFunc(membEml)}>
                                <p>{langData&&langData.EML_ATHN_EML_DOP_BTN_00}</p>
                                {/* 중복 확인 */}
                            </button>
                            :
                            <></>
                        }
                        <p className={emlAddrDopChkLbl==`${langData&&langData.EML_ATHN_EML_INPUT_LBL_04}`?"emlDupChkLbl active":"emlDupChkLbl"}>{emlAddrDopChkLbl}</p>
                        {/* 사용 가능한 이메일 입니다. */}
                    </div>
                    {emlAthnNoTimer > 0?
                        <div>
                            <button className="mt35" onClick={EmlAthnSendFunc}>
                                <p>{langData&&langData.EML_ATHN_NO_SEND_BTN_01}</p>
                               {/* 인증번호 */}
                            </button>
                        </div>:
                        <button className="mt35" onClick={EmlAthnSendFunc}>
                            <p>{langData&&langData.EML_ATHN_NO_SEND_BTN_00}</p>
                            {/* 인증번호 받기 */}
                        </button>
                    }
                </div>
                <div className="emailInputWrap">
                    <p>{langData&&langData.EML_ATHN_NO_INPUT_TITL_00}</p>
                    <div className="relative mt10">
                        <input 
                            type="text" 
                            placeholder={langData&&langData.EML_ATHN_NO_INPUT_DESC_00} 
                            value={authNoVal}
                            onChange={AuthNoValHandler}
                            maxLength={6}
                        />
                        {/* 인증번호를 입력해주세요. */}
                        {emlAthnNoTimer > 0?
                            <p className="timer">{timerMinutes}:{timerSecond}</p>:
                            <></>
                        }
                        <p className="emlDupChkLbl">{emlAthnChkLbl}</p>
                    </div>
                </div>
                <button className="athnBtn" onClick={()=>EmlAthnVrfFunc(authNoVal)}>
                    <p>{langData&&langData.EML_ATHN_NO_ATHN_BTN_00}</p>
                </button>
                <div className="capthCpyr"></div>
            </div>
        </div>,
        document.body
    );
}

export default EmlAthnModalUi;
